import { render } from "./EntitlementUpdateModal.vue?vue&type=template&id=1eee2e9c&scoped=true"
import script from "./EntitlementUpdateModal.vue?vue&type=script&lang=js"
export * from "./EntitlementUpdateModal.vue?vue&type=script&lang=js"

import "./EntitlementUpdateModal.vue?vue&type=style&index=0&id=1eee2e9c&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\orangehrm-5.7\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eee2e9c"]])

export default __exports__